import React, { useState, useRef, useEffect } from "react";
import {
  ChevronRight,
  ExternalLink,
  Globe,
  Server,
  Layers,
  Filter,
  X,
} from "lucide-react";

import "../App.css";
import "./projectTabs.css";
import ourprojectsphoto from "../../src/Assets/ourproj.jpg";

import siscobankSS from "../Assets/ProjectCardScreenshots/SiscoWebsiteHome.PNG";
import sabccoSS from "../Assets/ProjectCardScreenshots/SabccoWebsiteHome.PNG";
import sisSS from "../Assets/ProjectCardScreenshots/SISWebsiteHome.PNG";
import secSS from "../Assets/ProjectCardScreenshots/SECWebsiteHome.PNG";
import seedSS from "../Assets/ProjectCardScreenshots/seedhome.png";
import smumitraSS from "../Assets/ProjectCardScreenshots/mitra app.jpg";
import smuhrmsSS from "../Assets/ProjectCardScreenshots/SmuHrms.jpeg";
import mystichimalayanSS from "../Assets/ProjectCardScreenshots/MysticHimalayanWebsiteHome.PNG";
import tourismSS from "../Assets/ProjectCardScreenshots/TourismWebsiteHome.PNG";
import panchakSS from "../Assets/ProjectCardScreenshots/PanchakWebsiteHome.PNG";
import aashitatSS from "../Assets/ProjectCardScreenshots/aashitat_home.jpeg";
import eaglesNestSS from "../Assets/ProjectCardScreenshots/eaglesnesthome.PNG";
import positudeSS from "../Assets/ProjectCardScreenshots/PositudeWebsiteHome.PNG";
import sikkimawardsSS from "../Assets/ProjectCardScreenshots/SikkimAwardsWebsiteHome.PNG";
import smupniSS from "../Assets/ProjectCardScreenshots/SmuPniWebsiteHome.PNG";
import rsbSS from "../Assets/ProjectCardScreenshots/RSBWebsiteHomeIMG.png";
import gratitudeSS from "../Assets/ProjectCardScreenshots/gratitude_home.jpeg";
import nitSS from "../Assets/ProjectCardScreenshots/nit_home.jpeg";
import sicunSS from "../Assets/ProjectCardScreenshots/sicunhome.png";
import sicSS from "../Assets/ProjectCardScreenshots/sichome.png";
import siceSS from "../Assets/ProjectCardScreenshots/sicunEstore.png";
import stnmSS from "../Assets/ProjectCardScreenshots/stnmHome.png";
import stnmComplaintSS from "../Assets/ProjectCardScreenshots/stnmComplaint.png";
import stnmInventorySS from "../Assets/ProjectCardScreenshots/stnmInventory.png";
import kuberSS from "../Assets/ProjectCardScreenshots/kuber3.png";

import ProjectsCard from "../reusable-components/ProjectsCard";
import Heading from "../reusable-components/fonts/Heading";
import SubHeading from "../reusable-components/fonts/SubHeading";

import { motion } from "framer-motion";
import FadeInOnScroll from "../reusable-components/animations/FadeInOnScroll";
const projectsArray = [
  {
    id: 1,
    projectTitle: "Aashi Tours and Travels",
    projectSectors: [2],
    projectImage: aashitatSS,
    projectImageBlurHashString: "L?L4slj[WBja~qayaya|Wnayfka|",
    projectType: "Website",
    projectBrief:
      "This is the official website for Aashi Tours and Travels, which provides details about the business and the services it offers.",
    projectUrl: "/view-details/ashi",
    newTab: 1,
  },
  {
    id: 2,
    projectTitle: "Eagle's Nest Gangtok",
    projectSectors: [2],
    projectImage: eaglesNestSS,
    projectImageBlurHashString: "LB8O0T%MM{j]00InoJof~q%2t7of",
    projectType: "Website",
    projectBrief:
      "This is the official website for Eagle's Nest Gangtok, which provides details about the business and the services it offers.",
    projectUrl: "/view-details/eagles-nest",
    newTab: 1,
  },
  {
    id: 3,
    projectTitle: "Gratitude - Forever Grateful",
    projectSectors: [7],
    projectImage: gratitudeSS,
    projectImageBlurHashString: "LdL}1?M{RjWB~qRP%May-;t7IUof",
    projectType: "Portal",
    projectBrief:
      "An E-Commerce website developed for a Local Entrepreneur from Sikkim which is an exclusive platform catering to a wide range of customers with their unique apparels made in Sikkim.",
    projectUrl: "/view-details/gratitude",
    newTab: 1,
  },
  {
    id: 4,
    projectTitle: "Kuber World",
    projectSectors: [1],
    projectImage: kuberSS,
    projectImageBlurHashString: "LdL}1?M{RjWB~qRP%May-;t7IUof",
    projectType: "Portal",
    projectBrief:
      "Kuber World e-Finance is a micro-finance loan and recurring deposit management software designed to efficiently manage all daily transactions, including loan disbursements and collections from borrowers. It also handles recurring deposit transactions with ease, ensuring smooth and transparent financial operations.",
    projectUrl: "/view-details/kuber-world",
    newTab: 1,
  },
  //{
  //   id: 5,
  //   projectTitle: "Mystic Himalayan",
  //   projectSectors: [2],
  //   projectImage: mystichimalayanSS,
  //   projectImageBlurHashString: "LfFi}jahIVt6_4oLR*of-;oKoyf6",
  //   projectType: "Website",
  //   projectBrief:
  //     "This website serves as a marketing tool for Mystic Himalayan World Travels by exhibiting the services and amenities it provides, as well as information about its tours and treks and its locations. All devices, including desktop, laptop, tablet, and mobile, can access the website.",
  //   projectUrl: "https://mystichimalayan.com/",
  //   newTab: 1,
  // },
  {
    id: 6,
    projectTitle: "Namgyal Institute of Tibetology",
    projectSectors: [8],
    projectImage: nitSS,
    projectImageBlurHashString: "LHR2i1~qE0x]00%NM{t7M=D%xvV@",
    projectType: "Website",
    projectBrief:
      "Educational Institute‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ",
    projectUrl: "/view-details/nit",
    newTab: 1,
  },
  {
    id: 7,
    projectTitle: "Panchak Holidays",
    projectSectors: [2],
    projectImage: panchakSS,
    projectImageBlurHashString: "LB7-+,sm4:j]yZoeskkC9ZWA%MoL",
    projectType: "Website",
    projectBrief:
      "This is the official website for Panchak Holidays, which provides details about the business and the services it offers.",
    projectUrl: "/view-details/panchak",
    newTab: 1,
  },
  // {
  //   id: 8,
  //   projectTitle: "Positude",
  //   projectSectors: [5],
  //   projectImage: positudeSS,
  //   projectImageBlurHashString: "L48qKN?[+vEMR8n6?H%g7L-VPA^k",
  //   projectType: "Portal",
  //   projectBrief:
  //     "This is Positude's official website, which provides details about the business and details on recent and forthcoming events.",
  //   projectUrl: "https://positude.in/",
  //   newTab: 1,
  // },
  {
    id: 8,
    projectTitle: "Rajya Sainik Board",
    projectSectors: [4],
    projectImage: rsbSS,
    projectImageBlurHashString: "LWKnSIni?wt6^+S#M{o0TzRQi^kC",
    projectType: "Portal",
    projectBrief:
      "This is a dynamic website for the Department of Sainik Welfare (Government of Sikkim), which contains all information on state Sainik welfare and other activities linked to the armed forces. The website seeks to establish itself as a focal point for the transmission of information about numerous initiatives, programmes, and activities pertaining to the department. It's driven by a customised CMS (content management system), which gives the administrator easy and effective control over how its content is managed.",
    projectUrl: "/view-details/rsb",
    newTab: 0,
  },
  {
    id: 9,
    projectTitle: "SABCCO",
    projectSectors: [1],
    projectImage: sabccoSS,
    projectImageBlurHashString: "L130Ne+R?].l%f$,%zn94TM{TEHZ",
    projectType: "Portal",
    projectBrief:
      "The Web Portal will have the potential to disseminate information and awareness to individuals by offering 'anytime, anywhere' access to rich and relevant content on SABCCO's schemes, aims, goals, and loan-related information. With features like loan application, login options, picture upload options, notification and communication capabilities, etc., the portal will also include features to improve, simplify, automate, and digitise the back-office procedures for enhanced accuracy and efficiency.",
    projectUrl: "/view-details/sabcco",
    newTab: 0,
  },
  {
    id: 10,
    projectTitle: "SEED Cell",
    projectSectors: [5],
    projectImage: seedSS,
    projectImageBlurHashString: "LbIF#[oc%MWr00aeNHae~Va}RjoI",
    projectType: "Portal",
    projectBrief:
      "It is the official website for the Sikkim Entrepreneurship & Economic Development Society, whose goal is to create a thorough database of every entrepreneur in Sikkim. The site will aid in the development of a solid digital ecosystem by providing a platform for entrepreneurs to keep up with their online reputations, which will aid in their efforts to expand their customer base and build networks with other fellow entrepreneurs.",
    projectUrl: "/view-details/seed-cell",
    newTab: 0,
  },
  {
    id: 11,
    projectTitle: "SICUN",
    projectSectors: [4],
    projectImage: sicunSS,
    projectImageBlurHashString: "L89a,|IU_NM{t7j@x]WBM{j[ofay",
    projectType: "Portal",
    projectBrief:
      "The SICUN website provides updates, resources, and news for Sikkim’s cooperative sector.",
    projectUrl: "/view-details/sicun",
    newTab: 1,
  },
  {
    id: 12,
    projectTitle: "SICUN eStore",
    projectSectors: [7],
    projectImage: siceSS,
    projectImageBlurHashString: "LGF5}+Yk^6#M@-5c,1J5@[or[Q6.",
    projectType: "Portal",
    projectBrief:
      "The SICUN eStore provides fresh vegetables and other things right at your fingertips",
    projectUrl: "/view-details/sicun-estore",
    newTab: 1,
  },
  // {
  //   id: 14,
  //   projectTitle: "Sikkim Awards",
  //   projectSectors: [5],
  //   projectImage: sikkimawardsSS,
  //   projectImageBlurHashString: "L67nI0_NRPD%ROIVe.j[004n%M%M",
  //   projectType: "Portal",
  //   projectBrief:
  //     "It is a website that advertises Sikkim Awards 2022, which was held in Sikkim for the first time. The website is also accessible on all platforms, including desktop, laptop, tablet, and mobile.",
  //   projectUrl: "https://sikkimawards.com/",
  //   newTab: 1,
  // },
  {
    id: 13,
    projectTitle: "Sikkim Information Commission",
    projectSectors: [4],
    projectImage: sicSS,
    projectImageBlurHashString: "LGF5}+Yk^6#M@-5c,1J5@[or[Q6.",
    projectType: "Portal",
    projectBrief:
      "The SIC website provides RTI resources, decisions, and transparency-related updates for Sikkim.",
    projectUrl: "/view-details/sic",
    newTab: 1,
  },
  // {
  //   id: 15,
  //   projectTitle: "Sikkim Investment Summit",
  //   projectSectors: [4],
  //   projectImage: sisSS,
  //   projectImageBlurHashString: "LVN^h-t7?Gaet5R*M{R%?wjuIoWV",
  //   projectType: "Portal",
  //   projectBrief:
  //     "This is the Sikkim Investment Summit's official website, which offers details on the event.",
  //   projectUrl: "/view-details/sis",
  //   newTab: 0,
  // },
  {
    id: 14,
    projectTitle: "Sikkim Tourism",
    projectSectors: [2, 4],
    projectImage: tourismSS,
    projectImageBlurHashString: "LcF~pzRh-;WA_NX9RkWnx]xvRQjZ",
    projectType: "Portal",
    projectBrief:
      "This is the official web portal for the Tourism and Civil Aviation Deparment, Government of Sikkim, which features first-rate online resources and services. Included among the portal's unique features are: Content Management system, Service provider registration, Travel Card.",
    projectUrl: "/view-details/sikkim-tourism",
    newTab: 0,
  },
  {
    id: 15,
    projectTitle: "SISCO Bank",
    projectSectors: [1],
    projectImage: siscobankSS,
    projectImageBlurHashString: "LcH-lXAsR5t6~Wf+ozaypw$PNGV[",
    projectType: "Portal",
    projectBrief:
      "This is the official website for Sikkim State Co-operative Bank Pvt Ltd, which was created with the goal of giving its customers access to essential banking information. The website offers a section for the general public to make service requests, such as those for opening an account, credit counselling, requesting a chequebook, etc. The website contains comprehensive and adaptable admin features that make it simple to control and carefully review material before it is published.",
    projectUrl: "/view-details/sisco",
    newTab: 0,
  },
  {
    id: 16,
    projectTitle: "SMU HRMS",
    projectSectors: [6],
    projectImage: smuhrmsSS,
    projectImageBlurHashString: "L8Q0dd00000007N5xv^%~n-.t8R;",
    projectType: "Portal",
    projectUrl: "/view-details/sikkim-milk-hrms",
    projectBrief:
      "This is the official Human Resource Management software through which the administrator will be able to manage all data pertaining to employees of Sikkim Milk Union.",
    newTab: 1,
  },
  {
    id: 17,
    projectTitle: "SMU Mitra",
    projectSectors: [3],
    projectImage: smumitraSS,
    projectImageBlurHashString: "L5SY~#9W00-:$+xHxb-q~T9e-lM}",
    projectType: "Portal",
    projectUrl: "/view-details/sikkim-milk-mitra",
    projectBrief:
      "This is the official Sikkim Milk Union mobile app that allows registered agents, Army units, and institutions to regularly order items.",
    newTab: 0,
  },
  {
    id: 18,
    projectTitle: "SMU P&I",
    projectSectors: [3],
    projectImage: smupniSS,
    projectImageBlurHashString: "LTPGv,t6~qWBI[t6IUM{o}M_Rj%M",
    projectType: "Portal",
    projectBrief:
      "P&I web portal is a web application integrated with Sikkim Milk official website which is responsible for managing and keeping track of daily milk collection from various milk societies across Sikkim.",
    projectUrl: "/view-details/sikkim-milk-pni",
    newTab: 1,
  },
  {
    id: 19,
    projectTitle: "State Election Commission, Sikkim",
    projectSectors: [4],
    projectImage: secSS,
    projectImageBlurHashString: "LIJ[hm.ADjInMcNet6s9o#Vrxtxu",
    projectType: "Website",
    projectBrief:
      "This is the offical website for the State Election Commission, Government of Sikkim. It enables the general public to access government notices and circulars pertaining to elections. The website contains comprehensive and adaptable admin features that make it simple to control and carefully review material before it is published. It features all the characteristics of a contemporary website, including screen adaptation for various screen sizes (desktops, laptops, mobile phones & tablets).",
    projectUrl: "/view-details/sec",
    newTab: 0,
  },
  {
    id: 20,
    projectTitle: "STNM CMS",
    projectSectors: [4],
    projectImage: stnmComplaintSS,
    projectImageBlurHashString: "LGF5}+Yk^6#M@-5c,1J5@[or[Q6.",
    projectType: "Portal",
    projectBrief:
      "The complaint management portal for STNM Hospital‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎",
    projectUrl: "/view-details/stnm-cms/",
    newTab: 1,
  },
  {
    id: 21,
    projectTitle: "STNM Hospital",
    projectSectors: [4],
    projectImage: stnmSS,
    projectImageBlurHashString: "LGF5}+Yk^6#M@-5c,1J5@[or[Q6.",
    projectType: "Website",
    projectBrief:
      "The official website of Sir Thutob Namgyal Memorial (STNM) Hospital, located in Sochakgang, Gangtok",
    projectUrl: "/view-details/stnm/",
    newTab: 1,
  },
  {
    id: 22,
    projectTitle: "STNM IMS",
    projectSectors: [4],
    projectImage: stnmInventorySS,
    projectImageBlurHashString: "LGF5}+Yk^6#M@-5c,1J5@[or[Q6.",
    projectType: "Portal",
    projectBrief:
      "The inventory management portal for STNM Hospital‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎",
    projectUrl: "/view-details/stnm-ims/",
    newTab: 1,
  },
];

const projectsSectorsArr = [
  { id: 0, sectorName: "All Projects" },
  { id: 1, sectorName: "Banking & Finance" },
  { id: 2, sectorName: "Travel & Tourism" },
  { id: 3, sectorName: "Agriculture" },
  { id: 4, sectorName: "Government" },
  { id: 5, sectorName: "Business & Entrepreneurship" },
  { id: 6, sectorName: "HR Management" },
  { id: 7, sectorName: "E-Commerce" },
  { id: 8, sectorName: "Education" },
];

const ProjectCard = ({ project, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
          id={index}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
    <div
      className={`group relative bg-white/80 backdrop-blur-md rounded-3xl overflow-hidden border border-gray-200 hover:border-gray-300 hover:shadow-xl transition-all duration-700 hover:scale-[1.02] hover:-translate-y-2 transform-gpu ${
        index % 2 === 0 ? "animate-fade-in-up" : "animate-fade-in-up-delayed"
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        animationDelay: `${index * 0.1}s`,
        animationFillMode: "both",
      }}
    >
      {/* Gradient overlay */}
      <div className="gravity absolute inset-0 bg-gradient-to-br from-gray-100/50 via-gray-50/50 to-gray-100/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      {/* Image container */}
      <div className="gravity relative h-48 overflow-hidden p-t">
        <img
          src={project.projectImage}
          alt={project.projectTitle}
          className="gravity w-full h-full object-cover transition-transform duration-700"
        />

        <div className="gravity absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      
        {/* Project type badge */}
        <div className="gravity absolute top-4 left-4">
          <span
            className={`gravity inline-flex items-center px-3 py-1 rounded-full text-xs font-medium backdrop-blur-sm ${
              project.projectType === "Portal"
                ? "bg-gray-800/90 text-white"
                : "bg-gray-700/90 text-white"
            }`}
          >
            {project.projectType === "Portal" ? (
              <Server className="gravity w-3 h-3 mr-1" />
            ) : (
              <Globe className="gravity w-3 h-3 mr-1" />
            )}
            {project.projectType}
          </span>
        </div>

        {/* Year badge */}
        {/* <div className="absolute top-4 right-4">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white/90 backdrop-blur-sm text-gray-800">
            {project.year}
          </span>
        </div> */}
      </div>

      {/* Content */}
      <div className="gravity p-6 relative z-10">
        <h3 className="gravity text-xl font-bold text-gray-800 mb-3  transition-all duration-300 line-clamp-1">
          {project.projectTitle}
        </h3>

        <p className="gravity text-gray-600 text-sm mb-4 line-clamp-2 transition-colors duration-300">
          {project.projectBrief}
        </p>

        {/* Tech stack */}
        {project.tech && (
          <div className="gravity flex flex-wrap gap-2 mb-4">
            {project.tech.map((tech, i) => (
              <span
                key={i}
                className="gravity text-xs px-2 py-1 bg-gray-100 rounded-full text-gray-700 backdrop-blur-sm border border-gray-200"
              >
                {tech}
              </span>
            ))}
          </div>
        )}

        {/* Action button */}
        <button
          onClick={() => window.open(project.projectUrl, "_blank")}
          className="gravity w-full bg-[#8555C9] hover:bg-[#582e92] backdrop-blur-sm border   rounded-xl py-3 px-4 text-white font-medium transition-all duration-300  flex items-center justify-center gap-2"
        >
          <span>View Details</span>
          <ChevronRight className="gravity w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>

      {/* Hover glow effect */}
      <div className="gravity absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
        <div className="gravity absolute inset-0 rounded-3xl shadow-2xl shadow-gray-300/50" />
      </div>
    </div>
    </motion.div>
  );
};

const SectorTab = ({ sector, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`gravity relative px-6 py-3 rounded-2xl font-medium transition-all duration-300 transform hover:scale-105 ${
      isActive
        ? "bg-[#8555C9] text-white shadow-lg backdrop-blur-sm border border-white"
        : "text-gray-700 hover:text-gray-900 hover:bg-gray-200/50 backdrop-blur-sm border border-gray-200"
    }`}
  >
    {sector.sectorName}
    {isActive && (
      <div className="gravity absolute inset-0 rounded-2xl bg-gradient-to-r from-gray-700/20 to-gray-600/20 -z-10" />
    )}
  </button>
);

const FilterModal = ({
  isOpen,
  onClose,
  sectors,
  activeSector,
  onSectorChange,
}) => {
  if (!isOpen) return null;

  return (
    <div className="gravity fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="gravity bg-white/90 backdrop-blur-md rounded-3xl p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto border border-gray-200 shadow-xl">
        <div className="gravity flex justify-between items-center mb-6">
          <h3 className="gravity text-xl font-bold text-gray-800 ">
            Filter by Sector
          </h3>
          <button
            onClick={onClose}
            className="gravity text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="gravity w-6 h-6" />
          </button>
        </div>

        <div className="gravity grid grid-cols-1 sm:grid-cols-2 gap-3">
          {sectors.map((sector) => (
            <SectorTab
              key={sector.id}
              sector={sector}
              isActive={activeSector === sector.id}
              onClick={() => {
                onSectorChange(sector.id);
                onClose();
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const Projects = () => {
  const [activeProjectCategorizer, setActiveProjectCategorizer] = useState(1);
  const [activeSectorTab, setActiveSectorTab] = useState(0);
  const [filteredSectorWiseArray, setFilteredSectorWiseArray] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const filteredPortalArray = projectsArray.filter(
    (project) => project.projectType === "Portal"
  );

  const filteredWebsiteArray = projectsArray.filter(
    (project) => project.projectType === "Website"
  );

  const onActiveSectorChangeHandler = () => {
    let sectorWiseArr = projectsArray.filter((project) => {
      if (activeSectorTab === 0) {
        return true;
      } else return project?.projectSectors?.includes(activeSectorTab);
    });
    setFilteredSectorWiseArray(sectorWiseArr);
  };

  const onProjectCategoryClickHandler = (categoryID) => {
    setActiveProjectCategorizer(categoryID);
  };

  useEffect(() => {
    onActiveSectorChangeHandler();
  }, [activeSectorTab]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 relative overflow-hidden font-poppins">
      {/* Hero Section with Background Image */}
      <div className="relative max-h-[600px]">
        {/* Background Image */}
        <div
          className=" absolute inset-0 bg-cover bg-center bg-no-repeat filter brightness-50"
          style={{
            backgroundImage: `url(${ourprojectsphoto})`,
          }}
        />

        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/40" />

        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-white/10 rounded-full blur-3xl animate-pulse" />
          <div
            className="absolute -bottom-40 -left-40 w-80 h-80 bg-white/10 rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "1s" }}
          />
          <div
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "2s" }}
          />
        </div>
          
        {/* Content */}
        <div className="relative z-10 pt-20 pb-16">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <div className="animate-fade-in">
              <h1 className="text-5xl md:text-7xl font-bold mb-6 pt-16 sm:text-7xl">
                <span className="gravity text-white drop-shadow-2xl">
                  Our Projects
                </span>
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Category Tabs - Now properly separated from hero section */}
      <div className="relative z-10 bg-gradient-to-br from-gray-50 via-white to-gray-100 pt-12">
        <div className="max-w-7xl mx-auto px-4 mb-12 justify-center">
          <div className="flex flex-wrap justify-center gap-4 mb-8 bg-[#8555C9] px-3 w-full md:w-4/6 rounded-xl m-auto">
            {[
              { id: 1, label: "By Sectors", icon: Layers },
              { id: 2, label: "Portals", icon: Server },
              { id: 3, label: "Websites", icon: Globe },
            ].map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => onProjectCategoryClickHandler(id)}
                className={`
                  flex items-center gap-3 px-2 py-2 mt-1 md:px-6 md:py-3 font-medium transition-all duration-300 transform
                  ${
                    activeProjectCategorizer === id
                      ? "bg-white text-gray-700 backdrop-blur-sm gravity rounded-t-2xl "
                      : "bg-[#8555C9] text-white backdrop-blur-sm gravity border-gray-200 hover:text-gray-900 hover:bg-gray-200/50 rounded-2xl"
                  }
                `}
              >
                <Icon className="w-6 h-6 md:w-8 md:h-8 gravity hidden sm:block" />
                <span className="gravity">{label}</span>
              </button>
            ))}
          </div>

          {/* Mobile filter button */}
          {activeProjectCategorizer === 1 && (
            <div className="flex mb-8 md:hidden">
              <button
                onClick={() => setIsFilterModalOpen(true)}
                className=" gravity text-gray-600 flex items-center text-xs gap-2 px-2 py-1 bg-[ #e75124] backdrop-blur-sm border bg-[#FFFFFF] border-gray-600 rounded-2xl  font-medium hover:bg-[#582e92] transition-all duration-300 "
              >
                <Filter className="gravity w-5 h-5" />
                {"  "}Filter by Sector
              </button>
            </div>
          )}

          {/* Desktop sector tabs */}
          {activeProjectCategorizer === 1 && (
            <div className="hidden md:flex flex-wrap justify-center gap-3 mb-12">
              {projectsSectorsArr.map((sector) => (
                <SectorTab
                  key={sector.id}
                  sector={sector}
                  isActive={activeSectorTab === sector.id}
                  onClick={() => setActiveSectorTab(sector.id)}
                />
              ))}
            </div>
          )}
        </div>

        {/* Projects Grid */}
        <div className="max-w-7xl mx-auto px-4 pb-16 gravity ">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-14 lg:gap-y-14 md:gap-y-24" 
            >
            {activeProjectCategorizer === 1 &&
              filteredSectorWiseArray.map((project, index) => (
                <ProjectCard key={project.id} project={project} index={index} />
              ))}

            {activeProjectCategorizer === 2 &&
              filteredPortalArray.map((project, index) => (
                <ProjectCard key={project.id} project={project} index={index} />
              ))}

            {activeProjectCategorizer === 3 &&
              filteredWebsiteArray.map((project, index) => (
                <ProjectCard key={project.id} project={project} index={index} />
              ))}
          </div>

          {/* Empty state */}
          {((activeProjectCategorizer === 1 &&
            filteredSectorWiseArray.length === 0) ||
            (activeProjectCategorizer === 2 &&
              filteredPortalArray.length === 0) ||
            (activeProjectCategorizer === 3 &&
              filteredWebsiteArray.length === 0)) && (
            <div className="text-center py-24">
              <div className="text-6xl mb-4">🔍</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">
                No Projects Found
              </h3>
              <p className="text-gray-600">
                Try adjusting your filters or check back later for new projects.
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Filter Modal */}
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        sectors={projectsSectorsArr}
        activeSector={activeSectorTab}
        onSectorChange={setActiveSectorTab}
      />

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in-up-delayed {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.6s ease-out;
        }

        .animate-fade-in-up-delayed {
          animation: fade-in-up-delayed 0.6s ease-out;
        }

        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default Projects;
